export const state = {
  theme_appearance: 'light',
  mode: process.env.VUE_APP_ENV || 'development',
  settingDevelopmentFeatureFlag: process.env.VUE_APP_ENV === 'development',
  bookSourceParam: [],
}

export const mutations = {
  setAppearance(state, payload) {
    state.theme_appearance = payload
  },
  setSettingDevelopment(state, payload) {
    state.settingDevelopmentFeatureFlag = payload
  },
  setBookSource(state, payload) {
    var jsonParse = JSON.parse(payload.asString())
    state.bookSourceParam = jsonParse
  },
}
